import { create } from 'zustand';
import { User } from '@supabase/supabase-js';
import { supabase } from '../services/supabase';

interface AuthState {
  user: User | null;
  isLoggedIn: boolean;
  isLoading: boolean;
  isLoginModalOpen: boolean;
  setUser: (user: User | null) => void;
  openLoginModal: () => void;
  closeLoginModal: () => void;
  checkSession: () => Promise<void>;
  signOut: () => Promise<void>;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  isLoggedIn: false,
  isLoading: true,
  isLoginModalOpen: false,

  setUser: (user) => set({ user, isLoggedIn: !!user }),
  
  openLoginModal: () => set({ isLoginModalOpen: true }),
  
  closeLoginModal: () => set({ isLoginModalOpen: false }),

  checkSession: async () => {
    try {
      const { data: { session }, error } = await supabase.auth.getSession();
      if (error) throw error;
      set({ user: session?.user || null, isLoggedIn: !!session?.user, isLoading: false });
    } catch (error) {
      console.error('Error checking session:', error);
      set({ user: null, isLoggedIn: false, isLoading: false });
    }
  },

  signOut: async () => {
    await supabase.auth.signOut();
    set({ user: null, isLoggedIn: false });
  }
}));

// Setup listener for auth state changes
supabase.auth.onAuthStateChange((_event, session) => {
  useAuthStore.getState().setUser(session?.user || null);
});
